import { render } from "./TasksRibbon.vue?vue&type=template&id=72065f5a"
import script from "./TasksRibbon.vue?vue&type=script&lang=js"
export * from "./TasksRibbon.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.15.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__